/*
 * utils.quasar.date.ts
 */
import { date as $qDate } from 'quasar';
//
export class mcUtilsQuasarDate {
  public cpifGetToday(psSeparator = '-'): string {
    return $qDate.formatDate(new Date(), `YYYY${psSeparator}MMM${psSeparator}DD`);
  }
  //
  public cpifGetDiffSecond(pdDateStart: Date, pdDateEnd: Date): number {
    const lnDifference = $qDate.getDateDiff(pdDateStart, pdDateEnd, 'seconds');
    return lnDifference;
  }
  //
  public cpif2YYYYMMMDD(psDateIn: string | undefined): string {
    return $qDate.formatDate(psDateIn, 'YYYY-MMM-DD');
  }
  // 20240301: NOTE: psDateIn should not be undefined
  public cpif2YYYYMMDD(psDateIn: string | undefined): string {
    return $qDate.formatDate(psDateIn, 'YYYY-MM-DD');
  }
  // 20240301: Added to cater for null return
  public cpif2YYYYMMDDoNull(psDateIn: string | undefined | null): string | null {
    // console.log('cpif2YYYYMMDDoNull()-psDateIn-[', psDateIn, ']');
    // 20240221: Added undefined & null to prevent invalid formatting!
    if (undefined === psDateIn || null === psDateIn || '' === psDateIn) {
      return null; //psDateIn;
    }
    //
    return $qDate.formatDate(psDateIn, 'YYYY-MM-DD');
  }
  //
  public cpif2YYYYMMDDHHMMSS(psDateIn: string): string {
    // psDateIn: new Date().toISOString();
    // NOTE: DateTime is return in LOCAL time zone!!!
    return $qDate.formatDate(psDateIn, 'YYYY-MM-DD HH:mm:ss');
  }
  //
  public cpif2YYYYMMDDHHMMSSoNull(psDateIn: Date | string | undefined | null): string {
    if (undefined === psDateIn || null === psDateIn) {
      return '-';
    }
    // NOTE: DateTime is return in LOCAL time zone!!!
    return $qDate.formatDate(psDateIn, 'YYYY-MM-DD HH:mm:ss');
  }
  //
  public cpif2YYYYMMDDwoSep(psDateIn: string): string {
    return $qDate.formatDate(psDateIn, 'YYYYMMDD');
  }
  //
  public cpif2YYYYMMDDHHMMSSwoSep(psDateIn: string): string {
    return $qDate.formatDate(psDateIn, 'YYYYMMDD-HHmmss');
  }
  //
  public cpif2YYYYsMMsDD(pxDateIn: Date | string | null | undefined): string {
    if (null === pxDateIn || undefined === pxDateIn) {
      return '';
    }
    return $qDate.formatDate(pxDateIn, 'YYYY/MM/DD');
  }
  //
  public cpif2HHmm(pxDateIn: Date | string | null | undefined): string {
    if (null === pxDateIn || undefined === pxDateIn) {
      return '';
    }
    return $qDate.formatDate(pxDateIn, 'HH:mm');
  }
  // new Date().toISOString() => PostgreSQL timestamp
  // 2024-09-22T12:28:49.291Z => 2024-09-22 12:28:49.291000+8
  public cpif2PGSTimestamp(psDateISOIn: string | undefined | null): string {
    if (!psDateISOIn) {
      psDateISOIn = new Date().toISOString();
    }
    //
    const ldDate2Convert = new Date(psDateISOIn);
    const lnDate2ConvertOffset = -ldDate2Convert.getTimezoneOffset() / 60;
    const lsDate2ConvertSign = lnDate2ConvertOffset >= 0 ? '+' : '-';
    const lnDate2ConvertOffsetAbs = Math.abs(lnDate2ConvertOffset);
    const lsDate2ConvertOffset =
      lnDate2ConvertOffsetAbs < 10 ? '0' + lnDate2ConvertOffsetAbs.toString() : lnDate2ConvertOffsetAbs.toString();
    //
    let lsPGSTimestamp = psDateISOIn.replace('T', ' ');
    lsPGSTimestamp = lsPGSTimestamp.replace('Z', `000${lsDate2ConvertSign}${lsDate2ConvertOffset}`);
    //
    return lsPGSTimestamp;
  }
  //
  public cpifGetISOWeekNoInYear(psDateYYYYdMMdDD: string) {
    const ldDate = new Date(psDateYYYYdMMdDD);
    const lnISOWeekNoInYear = $qDate.getWeekOfYear(ldDate);
    //
    return lnISOWeekNoInYear;
  }
  //
  public cpif2DDsMMMsYYYY(pxDateIn: Date | string | null | undefined): string {
    if (null === pxDateIn || undefined === pxDateIn) {
      return '';
    }
    return $qDate.formatDate(pxDateIn, 'DD/MMM/YYYY');
  }
  //
  public cpif2YYYYMMMDDHHMMSS(psDateIn: string): string {
    // psDateIn: new Date().toISOString();
    // NOTE: DateTime is return in LOCAL time zone!!!
    return $qDate.formatDate(psDateIn, 'YYYY-MMM-DD HH:mm:ss');
  }
  //
}
//#end#
